import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import intl from 'react-intl-universal';
import { iconToIntl, keys } from '../../../../../../utils/Utils';

import './CancelButton.css';

class CancelButton extends Component {

    onKeyPress = e => {
        if (e.charCode === keys.ENTER) {
            this.props.cancelOnClick();
        }
    }

    render() {
        const { text } = this.props.icon;

        return (
            <li
                tabIndex="0"
                onKeyPress={e => this.onKeyPress(e)}
                onClick={this.props.cancelOnClick}
                className="CancelButton"
                aria-label={`Cancel Add ${text} ${intl.get(iconToIntl[this.props.type])}`}
            >
                <div className="icon">
                    <FontAwesomeIcon icon={faTimes} aria-hidden="true" />
                </div>
                <div className="text">
                    {text}
                </div>
            </li>
        );
    }
}

export default CancelButton;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/DrawerContainer/components/CancelButton/index.js